import * as React from "react";
import { LinkContainer } from "components/common/router";
import Routes from "routing/Routes";
import { Button } from "components/bootstrap";
const EditLinkButton = ({ authenticationBackendId, stepKey }) => /* @__PURE__ */ React.createElement(LinkContainer, { to: Routes.SYSTEM.AUTHENTICATION.BACKENDS.edit(authenticationBackendId, stepKey) }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", bsSize: "small" }, "Edit"));
export default EditLinkButton;
